import styled from "styled-components";
import Autocomplete from "@mui/material/Autocomplete";

export const StyledDropdown = styled(Autocomplete)`
  width: ${({ width }) => width};
`;
